// Отдельный сервис, для связывания разных сторов в общих действиях

import type { User } from '@devhacker/shared/features/user/types/user';
import { useTalkerStore } from '@devhacker/shared/plugins/talker/store/talker';
import { useSingleArticleStore } from '~/store/singleArticle';
import { useReactionsStore } from '~/store/reactions';
import { normalizeUserData } from '~/utils/normalizeUserData';
import { useUserStore } from './store';

export function useUserService() {
  const { $logger } = useNuxtApp();
  const userStore = useUserStore();
  const talkerStore = useTalkerStore();
  const log = $logger.withScope('👨🏻‍🍳 user-service');

  async function fetchAndUpdateUser(subId: string) {
    const userData = await useUserStore().fetchUser(subId);
    setUser(userData);
  }

  function setUser(userData: User) {
    userStore.setUser(userData);
    talkerStore.setUser(normalizeUserData(userData));
    fetchReactionsForCurrentArticle();
  }

  function patchUser(partialUser: Partial<User>) {
    talkerStore.setUser(normalizeUserData({ ...userStore.userData, ...partialUser }));
    userStore.patchUser(partialUser);
  }

  function clearUser() {
    log('clearUser');
    userStore.clearUser();
    talkerStore.clearUserData();
    fetchReactionsForCurrentArticle();
  }

  // private
  function fetchReactionsForCurrentArticle() {
    log('fetchReactionsForCurrentArticle');
    const slug = useSingleArticleStore().article?.name;
    slug && useReactionsStore().fetchReactions(slug);
  }

  return { fetchAndUpdateUser, setUser, patchUser, clearUser };
}
